import { render, staticRenderFns } from "./InActiveAccreditedSchools.vue?vue&type=template&id=07219a92&scoped=true"
import script from "./InActiveAccreditedSchools.vue?vue&type=script&lang=js"
export * from "./InActiveAccreditedSchools.vue?vue&type=script&lang=js"
import style0 from "./InActiveAccreditedSchools.vue?vue&type=style&index=0&id=07219a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07219a92",
  null
  
)

export default component.exports